module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "setParams"
    }
  }, [_c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.meta.title
    },
    on: {
      "change": function($event) {
        _vm.update('title', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Intro Text")]), _vm._v(" "), _c('textarea', {
    domProps: {
      "value": _vm.meta.intro
    },
    on: {
      "change": function($event) {
        _vm.update('intro', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Creator")]), _vm._v(" "), _c('input', {
    staticClass: "olpInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.meta.creator
    },
    on: {
      "change": function($event) {
        _vm.update('creator', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('input', {
    staticClass: "olpInput",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.meta.length
    },
    on: {
      "change": function($event) {
        _vm.update('length', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Publish")])]), _vm._v(" "), _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("meta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b07e718"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/meta_config.vue
// module id = 272
// module chunks = 1